import * as React from 'react';
import { Dispatch } from 'redux';

import { BaseApiGetRequest } from '../generic/baseApiGetRequest';
import { normalizeDefaultClipConfigutaion } from '../normalizers/clipTemplatesNormalizers';
import * as EntityNormalizers from '../normalizers/entityNormalizers';

export class GetDefaultClipTemplateConfiguration extends BaseApiGetRequest<
  string,
  EntityNormalizers.NormalizedSingleEntity<string>
> {
  constructor(component: React.Component, dispatch: Dispatch) {
    super(component, dispatch);
    this.path = `/clip-templates/default`;
    this.normalizeMethod = normalizeDefaultClipConfigutaion;
  }
}
